import { defaultNotificationOptionsSettingValue } from '../../../../../../../backend/config/settings/NotificationOptionsDefaultValue';
import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
import { useAlertConfig, useAlertUiTranslation } from '../../../../../../hooks';
import { useFormRow } from '../../Components/useFormRow';
export function usePhinMessagingPanel(config) {
    const { t } = useAlertUiTranslation();
    const { notificationOptions } = useAlertConfig();
    const mandatoryChannels = notificationOptions && notificationOptions.mandatoryChannels
        ? notificationOptions.mandatoryChannels
        : defaultNotificationOptionsSettingValue.mandatoryChannels;
    const phinOptions = notificationOptions && (notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.phinOptions)
        ? notificationOptions.phinOptions
        : defaultNotificationOptionsSettingValue.phinOptions;
    const deliveryTime = (phinOptions === null || phinOptions === void 0 ? void 0 : phinOptions.deliveryTime)
        ? phinOptions === null || phinOptions === void 0 ? void 0 : phinOptions.deliveryTime
        : defaultNotificationOptionsSettingValue.phinOptions.deliveryTime;
    const phinMessageTypes = (phinOptions === null || phinOptions === void 0 ? void 0 : phinOptions.messageTypes)
        ? phinOptions.messageTypes
        : defaultNotificationOptionsSettingValue.phinOptions.messageTypes;
    return {
        type: 'form.panel',
        hidden: {
            custom: (handler) => {
                return !handler.formParams.features.showPhin;
            },
        },
        style: {
            layout: 'column',
            paddingTop: config === null || config === void 0 ? void 0 : config.paddingTop,
            surface: 'level1',
        },
        children: [
            useFormRow([
                {
                    type: 'form.content',
                    key: 'content',
                    template: {
                        data: '',
                        content: `<div style="display: flex; align-items: center"> <span class="icon-monitor-heart-outlined grey-700"></span> <p style="font-size: 20px; padding-left: 16px" class="subtitle1">
                                ${t('wizard.defineDelivery.phinMessaging')}
                            </p></div>`,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        paddingLeft: config.mode === 'edit' ? 56 : 49,
                    },
                    children: [
                        {
                            type: 'form.label',
                            html: `<p class="subtitle1">${t('wizard.defineDelivery.phinDirectCommunication')}</p>`,
                            style: {
                                layout: 'horizontal',
                            },
                            component: {
                                type: 'form.radio',
                                key: 'phin',
                                event: {
                                    onChange: (value, handler) => {
                                        const channelsWidget = findChannelsWidget(handler, config.mode);
                                        const configValues = channelsWidget === null || channelsWidget === void 0 ? void 0 : channelsWidget.config.values;
                                        if (value === true && channelsWidget) {
                                            if (handler.formData.channels === undefined || handler.formData.channels.length === 0) {
                                                handler.formData.channels = ['inbox'];
                                            }
                                            else if (!handler.formData.channels.includes('inbox')) {
                                                handler.formData.channels.push('inbox');
                                            }
                                            if (handler.formData.allowResponse === undefined) {
                                                handler.formData.allowResponse = true;
                                            }
                                            if (Array.isArray(configValues)) {
                                                configValues.forEach((channel) => {
                                                    if (channel.value === 'inbox') {
                                                        channel.disabled = true;
                                                    }
                                                });
                                            }
                                            channelsWidget.update();
                                        }
                                        else if (value === false && channelsWidget) {
                                            if (Array.isArray(configValues)) {
                                                configValues.forEach((channel) => {
                                                    if (channel.value === 'inbox' && !mandatoryChannels.includes('inbox')) {
                                                        channel.disabled = false;
                                                    }
                                                });
                                            }
                                            channelsWidget.update();
                                        }
                                    },
                                },
                                style: {
                                    inline: true,
                                },
                                values: [
                                    {
                                        label: t('common.no'),
                                        value: false,
                                    },
                                    {
                                        label: t('common.yes'),
                                        value: true,
                                    },
                                ],
                                defaultValue: false,
                            },
                        },
                        {
                            type: 'form.panel',
                            key: 'phinOptions',
                            hidden: {
                                when: '^phin',
                                dataNotEq: true,
                            },
                            children: [
                                {
                                    type: 'form.label',
                                    html: `<p class="subtitle1">${t('wizard.defineDelivery.phinMessageDetails')}</p>`,
                                },
                                {
                                    type: 'form.label',
                                    html: `<p class="body2">${t('wizard.defineDelivery.phinSensitivity')}</p>`,
                                    style: {
                                        layout: 'horizontal',
                                    },
                                    component: {
                                        type: 'form.radio',
                                        key: 'communicationSensitive',
                                        style: {
                                            inline: true,
                                        },
                                        values: [
                                            {
                                                label: t('common.no'),
                                                value: false,
                                            },
                                            {
                                                label: t('common.yes'),
                                                value: true,
                                            },
                                        ],
                                        defaultValue: false,
                                    },
                                },
                                {
                                    type: 'form.content',
                                    key: 'communicationSensitiveContent',
                                    render: (handler) => {
                                        var _a;
                                        return (React.createElement(React.Fragment, null, handler.formData.phin && ((_a = handler.formData.phinOptions) === null || _a === void 0 ? void 0 : _a.communicationSensitive) && (React.createElement(Box, { pt: 1 },
                                            React.createElement(Alert, { severity: 'info' },
                                                React.createElement(Typography, { variant: 'subtitle2', sx: { fontWeight: 400 } }, t('wizard.defineDelivery.deliveryMethodCommunicationSensitive')))))));
                                    },
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                    },
                                    children: [
                                        {
                                            type: 'alert.customLayout',
                                            childrenSx: [
                                                {
                                                    width: {
                                                        xl: '70%',
                                                        lg: '70%',
                                                        md: '90%',
                                                    },
                                                },
                                            ],
                                            children: [
                                                {
                                                    type: 'form.panel',
                                                    children: [
                                                        {
                                                            type: 'alert.phinIdentifier',
                                                            key: 'uniqueIdentifier',
                                                            validate: {
                                                                required: true,
                                                                requiredMessage: t('common.required'),
                                                            },
                                                            generateUniqueIdentifier: config.generateUniqueIdentifier,
                                                        },
                                                        {
                                                            type: 'form.select',
                                                            label: t('wizard.defineDelivery.phinMessageType'),
                                                            key: 'messageType',
                                                            defaultValue: 'alert',
                                                            values: phinMessageTypes.map((value) => ({
                                                                value: value,
                                                                label: value.charAt(0).toUpperCase() + value.slice(1),
                                                            })),
                                                            validate: {
                                                                required: true,
                                                                requiredMessage: t('common.required'),
                                                            },
                                                        },
                                                        {
                                                            type: 'form.select',
                                                            label: t('wizard.defineDelivery.urgency.title'),
                                                            key: 'urgencyOfEvent',
                                                            values: mapPhinOptionLabelValue((phinOptions === null || phinOptions === void 0 ? void 0 : phinOptions.urgencyOfEvent)
                                                                ? phinOptions.urgencyOfEvent
                                                                : defaultNotificationOptionsSettingValue.phinOptions.urgencyOfEvent),
                                                            validate: {
                                                                required: true,
                                                                requiredMessage: t('common.required'),
                                                            },
                                                        },
                                                        {
                                                            type: 'form.select',
                                                            label: t('wizard.defineDelivery.severity.title'),
                                                            key: 'severityOfEvent',
                                                            values: mapPhinOptionLabelValue((phinOptions === null || phinOptions === void 0 ? void 0 : phinOptions.severityOfEvent)
                                                                ? phinOptions.severityOfEvent
                                                                : defaultNotificationOptionsSettingValue.phinOptions
                                                                    .severityOfEvent),
                                                            validate: {
                                                                required: true,
                                                                requiredMessage: t('common.required'),
                                                            },
                                                        },
                                                        {
                                                            type: 'form.select',
                                                            label: t('wizard.defineDelivery.certainty.title'),
                                                            key: 'certaintyOfEvent',
                                                            values: mapPhinOptionLabelValue((phinOptions === null || phinOptions === void 0 ? void 0 : phinOptions.certaintyOfEvent)
                                                                ? phinOptions.certaintyOfEvent
                                                                : defaultNotificationOptionsSettingValue.phinOptions
                                                                    .certaintyOfEvent),
                                                            validate: {
                                                                required: true,
                                                                requiredMessage: t('common.required'),
                                                            },
                                                        },
                                                        {
                                                            type: 'form.select',
                                                            label: t('wizard.defineDelivery.deliveryTime.title'),
                                                            key: 'deliveryTimeInMinutes',
                                                            values: deliveryTime.map((data) => ({
                                                                value: data.value,
                                                                label: data.title,
                                                            })),
                                                            validate: {
                                                                required: true,
                                                                requiredMessage: t('common.required'),
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    type: 'form.label',
                                    html: `<p class="body2">${t('wizard.defineDelivery.requireAcknowledgement')}</p>`,
                                    style: {
                                        layout: 'horizontal',
                                    },
                                    component: {
                                        type: 'form.radio',
                                        key: 'recipientAcknowledge',
                                        event: {
                                            onChange: (value, handler) => {
                                                if (value && handler.formData.allowResponse !== undefined) {
                                                    if (value === true) {
                                                        handler.formData.allowResponse = true;
                                                    }
                                                    if (value === false) {
                                                        handler.formData.allowResponse = undefined;
                                                    }
                                                }
                                            },
                                        },
                                        style: {
                                            inline: true,
                                        },
                                        values: [
                                            {
                                                label: t('common.no'),
                                                value: false,
                                            },
                                            {
                                                label: t('common.yes'),
                                                value: true,
                                            },
                                        ],
                                        defaultValue: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ], config.mode),
        ],
    };
}
function findChannelsWidget(handler, mode) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let widget;
    if (mode === 'edit') {
        widget = (_d = (_c = (_b = (_a = handler
            .upByType('form')) === null || _a === void 0 ? void 0 : _a.down('!deliveryMethods')) === null || _b === void 0 ? void 0 : _b.down('!deliveryChannelsLayout')) === null || _c === void 0 ? void 0 : _c.down('!channelsPanel')) === null || _d === void 0 ? void 0 : _d.down('channels');
    }
    else {
        widget = (_j = (_h = (_g = (_f = (_e = handler
            .upByType('form')) === null || _e === void 0 ? void 0 : _e.down('!alertPanel')) === null || _f === void 0 ? void 0 : _f.down('!deliveryMethods')) === null || _g === void 0 ? void 0 : _g.down('!deliveryChannelsLayout')) === null || _h === void 0 ? void 0 : _h.down('!channelsPanel')) === null || _j === void 0 ? void 0 : _j.down('channels');
    }
    return widget;
}
function mapPhinOptionLabelValue(option) {
    return option.map((value) => ({
        value: value.toLowerCase(),
        label: value,
    }));
}
